import React from "react";
import { useTranslation } from "react-i18next";
import { Img } from "react-image";
import { connect } from "react-redux";
import { SecondaryButton } from "Shared/Buttons";
import CalculatedPayment from "Shared/CalculatedPayment";
import { withTheme } from "styled-components";
import { getBankLogoSrc } from "src/store/selectors/banks";
import { isCalculateTaxesCustomerRequest } from "src/store/selectors/financeSettings";
import { isVehicleUpdating } from "src/store/selectors/vehicles";
import { getSelectedPaymentType } from "src/utils/vehicles";
import { ApplicationStore, VehicleState } from "Types/state";
import "./BankOfferItem.scss";
import { WithTheme } from "src/styles/createStyledComponentsTheme";
import { openSubModal } from "src/store/actions/onlineShopper/subModal";

export interface BankOfferItemProps {
    id: number;
    selected: number | null;
    offer: any;
    onUpdate: (value: number) => void;
    vehicle: VehicleState;
    vin: string;
}

const BankOfferItem = ({
    account,
    bankLogoSrc,
    id,
    isTaxesCustomerRequested,
    isUpdating,
    offer,
    onUpdate,
    selected,
    theme,
    vehicle,
    vin,
    openCustomizedPaymentModal,
}: BankOfferItemProps & ReturnType<typeof mapStateToProps> & typeof mapDispatch & WithTheme) => {
    const vehicleDeal = {
        offerIndex: id,
        payments: vehicle.payments,
        selectedPaymentIndex: getSelectedPaymentType(vehicle),
        tip: "",
        vin: vehicle.vin,
    };
    const { t } = useTranslation();

    const selectThisOffer = () => {
        onUpdate(id);
    };

    return (
        <div className="bank_offer_item">
            <Img src={bankLogoSrc} className="logo" unloader={<div className={"lender_name"}>{offer.lender}</div>} />
            <section>
                <CalculatedPayment
                    account={account}
                    phoneNumber={account.phone!}
                    displayPaymentInfo={!isTaxesCustomerRequested}
                    {...vehicleDeal}
                    inGarage={true}
                />
            </section>

            <div
                className={`expand`}
                onClick={() => openCustomizedPaymentModal(id, vin)}
                style={{ color: theme.palette.primary.main, textAlign: "center" }}
            >
                {t("ViewOfferDetails")}
            </div>

            <SecondaryButton onClick={selectThisOffer} disabled={id === selected || isUpdating}>
                {t("MyGarage.BankOffers.BankOfferItem.selectOffer")}
            </SecondaryButton>
        </div>
    );
};

function mapStateToProps(state: ApplicationStore, { offer, vin }: BankOfferItemProps) {
    return {
        isTaxesCustomerRequested: isCalculateTaxesCustomerRequest(state),
        account: state.account,
        bankLogoSrc: getBankLogoSrc(state, offer.lender),
        isUpdating: isVehicleUpdating(state, vin),
    };
}

const mapDispatch = {
    openCustomizedPaymentModal: (bankOfferIndex: number, vin: string) =>
        openSubModal({ modalType: "paymentPlanReviewModal", bankOfferIndex, vin }),
};

export default withTheme(connect(mapStateToProps, mapDispatch)(BankOfferItem));
